import Vue from 'vue'
import { AxiosError, AxiosResponse } from 'axios'

const lotRelations = ['product', 'origin', 'uses', 'stock_location']

const needFetchLot = (lot: KwixeoCatalog.ProductLot): boolean => {
  return !lotRelations.every(relation => relation in lot)
}

const fetchLot = async (id: number|string): Promise<KwixeoCatalog.ProductLot> => {
  return await Vue.prototype.$kwCatalog.axios.get('/catalog/stock/lot/' + id, {
      params: {
        include: lotRelations.join(',')
      }
    })
    .then((response: AxiosResponse) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      throw new Error((error.response as AxiosResponse)?.data)
    })
}

export {
  lotRelations, needFetchLot, fetchLot
}
